export class CardTypeValueApiModel {
  paymentValue: number;

  bonusValue: number;
}
